export default "__VITE_ASSET__B0GRQKPU__"